/**
 * A/B Test — Vacuum Kit compare ("Smarter Packing, More Freedom")
 * Toggle: body[data-vacuum-compare-ab="true|false"]
 *   - false (Control): current "Why Aerless™ Wins" compare table
 *   - true  (Variant): product art + clickable Aerless vs Others table
 *
 * Vacuum Kit PDP only. For Intelligems, set data-vacuum-compare-ab on <body>.
 */
(function () {
  'use strict';

  if (window.__vacuumCompareAbInit) return;
  window.__vacuumCompareAbInit = true;

  var ATTR = 'data-vacuum-compare-ab';
  var VARIANT_ATTR = 'data-vacuum-compare-ab-variant';
  var VARIANT_VERSION = 'icons-v3-cdn-svg';
  var ACTIVE_CLASS = 'vacuum-compare-ab--active';
  var HIDDEN_CLASS = 'vacuum-compare-ab__control-hidden';
  var lastEnabled = null;
  var timer = null;
  var applying = false;
  var lastAttrValue = null;

  var CHECK_SVG =
    '<svg class="vacuum-compare-ab__icon-check" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="11" fill="#ff5801"/>' +
    '<path d="M7.2 12.4l3 3.1 6.6-6.8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var CROSS_SVG =
    '<svg class="vacuum-compare-ab__icon-cross" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' +
    '<circle cx="12" cy="12" r="11" fill="#e8e8e8"/>' +
    '<path d="M8.2 8.2l7.6 7.6M15.8 8.2l-7.6 7.6" stroke="#9a9a9a" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>';

  /* CDN SVGs — original colors preserved (do not recolor via CSS/filters) */
  var ICON_URLS = {
    space: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_12.svg?v=1787825468',
    compress: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_13.svg?v=1787825467',
    pump: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Group_1000014968_1.svg?v=1787825468',
    odor: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_14.svg?v=1787825467',
    waterproof: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_15.svg?v=1787825467',
    returns: 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_16.svg?v=1787825468'
  };

  var FEATURES = [
    { id: 'space', label: 'Optimizes luggage space', aerless: true, others: true, icon: 'space' },
    { id: 'compress', label: 'Compresses 15+ items', aerless: true, others: false, icon: 'compress' },
    { id: 'pump', label: 'Rechargeable air pump', aerless: true, others: false, icon: 'pump' },
    { id: 'odor', label: 'Keeps clothes odor-free', aerless: true, others: false, icon: 'odor' },
    { id: 'waterproof', label: 'Waterproof anti-rip nylon', aerless: true, others: false, icon: 'waterproof' },
    { id: 'returns', label: '100 day hassle-free returns', aerless: true, others: false, icon: 'returns' }
  ];

  function isAbEnabled() {
    if (!document.body) return false;
    return document.body.getAttribute(ATTR) === 'true' ||
      document.documentElement.getAttribute(ATTR) === 'true';
  }

  function isVacuumKitPdp() {
    if (document.querySelector('product-gallery[data-gallery-vacuum-kit-pdp="true"]')) {
      return true;
    }
    var path = String(location.pathname || '').toLowerCase();
    return path.indexOf('vacuum-kit') > -1 ||
      path.indexOf('aerless-vacuum-kit') > -1 ||
      path.indexOf('aerless%E2%84%A2-vacuum-kit') > -1;
  }

  function getImageUrl() {
    var script = document.querySelector('script[data-vacuum-compare-ab-image]');
    return script ? script.getAttribute('data-vacuum-compare-ab-image') : '';
  }

  function featureIconHtml(key) {
    var url = ICON_URLS[key];
    if (!url) return '';
    return '<img class="vacuum-compare-ab__feature-img" src="' + url + '" alt="" width="24" height="24" loading="lazy" decoding="async">';
  }

  function getCompareRoot() {
    if (!isVacuumKitPdp()) return null;
    return document.querySelector('.comparison-section');
  }

  function getSectionShell(root) {
    return root.closest('.shopify-section') || root.parentElement;
  }

  function markCell(hasIt) {
    return hasIt
      ? '<span class="vacuum-compare-ab__mark vacuum-compare-ab__mark--yes">' + CHECK_SVG + '<span class="sr-only">Yes</span></span>'
      : '<span class="vacuum-compare-ab__mark vacuum-compare-ab__mark--no">' + CROSS_SVG + '<span class="sr-only">No</span></span>';
  }

  function buildTableRowsHtml() {
    var html = '';
    FEATURES.forEach(function (f) {
      html +=
        '<tr class="vacuum-compare-ab__row" data-feature-id="' + f.id + '" tabindex="0" aria-pressed="false">' +
        '<th scope="row" class="vacuum-compare-ab__feature">' +
        '<span class="vacuum-compare-ab__feature-icon">' + featureIconHtml(f.icon) + '</span>' +
        '<span class="vacuum-compare-ab__feature-label">' + f.label + '</span>' +
        '</th>' +
        '<td class="vacuum-compare-ab__col-aerless">' + markCell(f.aerless) + '</td>' +
        '<td class="vacuum-compare-ab__col-others">' + markCell(f.others) + '</td>' +
        '</tr>';
    });
    return html;
  }

  function buildVariant(imageUrl) {
    var wrap = document.createElement('div');
    wrap.className = 'vacuum-compare-ab__variant';
    wrap.setAttribute(VARIANT_ATTR, VARIANT_VERSION);
    wrap.innerHTML =
      '<div class="vacuum-compare-ab__layout">' +
        '<div class="vacuum-compare-ab__visual">' +
          (imageUrl
            ? '<img class="vacuum-compare-ab__product" src="' + imageUrl + '" alt="Aerless compression bag and rechargeable air pump" width="926" height="1004" loading="lazy" decoding="async">'
            : '') +
        '</div>' +
        '<div class="vacuum-compare-ab__copy">' +
          '<h2 class="vacuum-compare-ab__title">Smarter Packing, More Freedom</h2>' +
          '<p class="vacuum-compare-ab__subtitle">The Aerless Compression Bag is designed to help you pack more, stay organized, and travel worry-free. Engineered for performance, built for explorers.</p>' +
          '<div class="vacuum-compare-ab__table-wrap">' +
            '<table class="vacuum-compare-ab__table">' +
              '<thead>' +
                '<tr>' +
                  '<th scope="col">Features</th>' +
                  '<th scope="col" class="vacuum-compare-ab__col-aerless">Aerless<span class="vacuum-compare-ab__tm">™</span></th>' +
                  '<th scope="col" class="vacuum-compare-ab__col-others">Others</th>' +
                '</tr>' +
              '</thead>' +
              '<tbody>' + buildTableRowsHtml() + '</tbody>' +
            '</table>' +
          '</div>' +
        '</div>' +
      '</div>';
    bindInteractions(wrap);
    return wrap;
  }

  function setActiveFeature(root, featureId) {
    root.querySelectorAll('[data-feature-id]').forEach(function (el) {
      var on = el.getAttribute('data-feature-id') === featureId;
      el.classList.toggle('is-active', on);
      if (el.hasAttribute('aria-pressed')) {
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });

    var row = root.querySelector('.vacuum-compare-ab__row[data-feature-id="' + featureId + '"]');
    if (row && typeof row.scrollIntoView === 'function') {
      row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function bindInteractions(root) {
    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-feature-id]');
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      setActiveFeature(root, target.getAttribute('data-feature-id'));
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target.closest('[data-feature-id]');
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      setActiveFeature(root, target.getAttribute('data-feature-id'));
    });
  }

  function hideControl(root) {
    Array.prototype.forEach.call(root.children, function (child) {
      if (child.hasAttribute(VARIANT_ATTR)) return;
      child.classList.add(HIDDEN_CLASS);
    });
  }

  function showControl(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.' + HIDDEN_CLASS), function (el) {
      el.classList.remove(HIDDEN_CLASS);
    });
  }

  function removeVariant(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[' + VARIANT_ATTR + ']'), function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function applyVariant() {
    var root = getCompareRoot();
    if (!root) return;

    if (document.body && !document.body.classList.contains(ACTIVE_CLASS)) {
      document.body.classList.add(ACTIVE_CLASS);
    }
    hideControl(root);

    var existing = root.querySelector('[' + VARIANT_ATTR + '="' + VARIANT_VERSION + '"]');
    if (existing) {
      var shellOk = getSectionShell(root);
      if (shellOk && !shellOk.classList.contains('vacuum-compare-ab--section')) {
        shellOk.classList.add('vacuum-compare-ab--section');
      }
      return;
    }

    removeVariant(root);
    root.appendChild(buildVariant(getImageUrl()));

    var shell = getSectionShell(root);
    if (shell && !shell.classList.contains('vacuum-compare-ab--section')) {
      shell.classList.add('vacuum-compare-ab--section');
    }
  }

  function restoreControl() {
    var root = getCompareRoot();
    if (document.body && document.body.classList.contains(ACTIVE_CLASS)) {
      document.body.classList.remove(ACTIVE_CLASS);
    }

    if (!root) {
      document.querySelectorAll('.vacuum-compare-ab--section').forEach(function (el) {
        el.classList.remove('vacuum-compare-ab--section');
      });
      return;
    }

    removeVariant(root);
    showControl(root);

    var shell = getSectionShell(root);
    if (shell) shell.classList.remove('vacuum-compare-ab--section');
  }

  function run() {
    if (applying) return;
    applying = true;

    try {
      var enabled = isAbEnabled() && isVacuumKitPdp();
      if (enabled === lastEnabled) {
        if (enabled) {
          /* Re-check DOM only if variant missing (e.g. section re-rendered) */
          var root = getCompareRoot();
          if (root && !root.querySelector('[' + VARIANT_ATTR + '="' + VARIANT_VERSION + '"]')) {
            applyVariant();
          }
        }
        return;
      }

      lastEnabled = enabled;
      if (enabled) applyVariant();
      else restoreControl();
    } finally {
      applying = false;
    }
  }

  function scheduleRun() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, 40);
  }

  function boot() {
    lastAttrValue = document.body ? document.body.getAttribute(ATTR) : null;
    run();
    [100, 400, 1000].forEach(function (ms) {
      setTimeout(run, ms);
    });

    if (document.body) {
      new MutationObserver(function (mutations) {
        var i;
        var next;
        for (i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName !== ATTR) continue;
          next = document.body.getAttribute(ATTR);
          if (next === lastAttrValue) return;
          lastAttrValue = next;
          scheduleRun();
          return;
        }
      }).observe(document.body, { attributes: true, attributeFilter: [ATTR] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
